import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/ui/dialog";
import { Button } from "@/shared/ui/button";
import { useId } from "react";
import type { CategoryAttributeResponse } from "@/services/api";

interface AttributeDeleteDialogProps {
  open: boolean;
  attribute: CategoryAttributeResponse | null;
  isLoading?: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function AttributeDeleteDialog({
  open,
  attribute,
  isLoading,
  onOpenChange,
  onConfirm,
}: AttributeDeleteDialogProps) {
  const descriptionId = useId();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={descriptionId}>
        <DialogHeader>
          <DialogTitle>Delete attribute</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete the attribute{" "}
            <span className="font-medium text-ink-900">
              {attribute?.name ?? "this attribute"}
            </span>
            ? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-4">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
